import {login} from '@/api/authApi';
import {getCustomerProfile} from '@/api/customerApi';
import {setAuthorizationToken} from '@/axios';
import {defineStore} from 'pinia';

import {showError} from '../services/alertService';
import {useCartStore} from './cartStore';

export const useAuthStore = defineStore('authStore', {
    state: () => ({
        user: null,
        userDetails: null,
    }),

    getters: {
        isLogined(store) {
            return !!store.user;
        },

        getUser(store) {
            return store.user;
        },

        getUserDetails(store) {
            return store.userDetails;
        },
    },

    actions: {
        async login(credentials) {
            const user = await login(credentials);
            this.setUser(user);
            try {
                await useCartStore().syncCarts();
            } catch {
                // actors JWT is valid; store cart/user-v1 still 500/406
            }
        },

        async loginMobileApp() {
            if (!window.MobileApp) {
                return;
            }

            const credentialsData = window.MobileApp.getAuthData();
            const credentials = JSON.parse(credentialsData);
            // alert(`login: ${credentials.userLogin} | pass: ${credentials.userPass}`);

            await this.login(credentials);
        },

        async loadUserDetails() {
            this.userDetails = await getCustomerProfile();
        },

        setUser(user) {
            this.user = user;
            localStorage.setItem('user', JSON.stringify(user));
            setAuthorizationToken(user.jwt);
            this.loadUserDetails().catch((error) => {
                this.userDetails = null;
                showError(error.message);
            });
        },

        async logout() {
            localStorage.removeItem('user');
            await this.loginMobileApp();
            location.reload();
        },
    },
});
